import { Link } from 'react-router-dom';

export default function HeroBanner() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '樱花视频 - 首页',
    description: '樱花视频汇集香蕉视频、红桃视频、蜜桃视频、糖豆视频等同类优质平台，提供高清免费在线观看推荐。',
    url: 'https://hongfengyi.cn/',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20cinematic%20light%20streaks%20in%20coral%20orange%20and%20cream%20tones%2C%20soft%20bokeh%20effects%2C%20dreamy%20atmospheric%20texture%2C%20minimalist%20artistic%20composition%2C%20smooth%20curves%20and%20gentle%20light%20patterns%2C%20modern%20elegant%20design%20aesthetic%2C%20no%20text%20no%20people%20just%20abstract%20beautiful%20background&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="樱花视频 - 视频平台推荐"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

        <div className="relative z-10 w-full px-4 md:px-6 text-center">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
              发现最适合你的
              <span className="text-accent-400">视频平台</span>
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
              樱花视频汇集香蕉视频、红桃视频、蜜桃视频、糖豆视频等同类优质平台，
              提供高清免费在线观看，海量电影电视剧全集不卡顿，轻松找到你喜欢的视频网站。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/all"
                className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-background-50 text-base font-medium hover:bg-primary-600 transition-all cursor-pointer"
              >
                浏览全部平台
              </Link>
              <Link
                to="/about"
                className="whitespace-nowrap px-8 py-3 rounded-full bg-white/15 text-white text-base font-medium hover:bg-white/25 transition-all cursor-pointer backdrop-blur-sm border border-white/20"
              >
                了解更多
              </Link>
            </div>

            <div className="flex items-center justify-center gap-8 mt-10">
              {[
                { value: '50+', label: '视频平台' },
                { value: '10万+', label: '影视资源' },
                { value: '99.9%', label: '流畅播放' },
                { value: '500万+', label: '活跃用户' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-white">{stat.value}</div>
                  <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}